import React from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import envConfig from "../../envConfig/envHelper";

const MockAuth0Provider = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const isTestMode =
    typeof window !== "undefined" &&
    (window as Window & { __PLAYWRIGHT_TEST__?: boolean }).__PLAYWRIGHT_TEST__;

  if (isTestMode) {
    return <MockAuth0Provider>{children}</MockAuth0Provider>;
  }

  const { auth } = envConfig;

  const onRedirectCallback = () => {
    window.history.replaceState({}, document.title, "/ocportal");
  };

  return (
    <Auth0Provider
      domain={auth.domain}
      clientId={auth.clientId}
      onRedirectCallback={onRedirectCallback}
      authorizationParams={{
        // eslint-disable-next-line
        redirect_uri: auth.loginCallback,
        scope: auth.scope,
        audience: auth.audience,
      }}
    >
      {children}
    </Auth0Provider>
  );
};
